class Adcount {
    constructor(adInfo) {
        this.init(adInfo);
    }

    init(adInfo) {
        this.initParams(adInfo);
        this.initFlag(adInfo);
    }

    initParams(adInfo) {
        if (adInfo.code === 1 && adInfo.info.length !== 0) {
            this.ads = this.classify(adInfo.info);
            this.preAds = this.ads[1]; // 前贴片，包含广告、片头
            this.pauseAds = this.ads[3];
            this.cornerAds = this.ads[4];
            this.bannerAds = this.ads[5];
        }
    }

    initFlag(adInfo) {
        if (adInfo.code === 1 && adInfo.info.length !== 0) {
            this.preFlag = this.getFlag(this.preAds, 1);
            this.pauseFlag = this.getFlag(this.pauseAds, 3);
            this.cornerFlag = this.getFlag(this.cornerAds, 4);
            this.bannerFlag = this.getFlag(this.bannerAds, 5);
        }
    }

    classify(arr) {
        const preAds = [];
        const pauseAds = [];
        const cornerAds = [];
        const bannerAds = [];

        if (arr.length === 0) return {};

        for (const item of arr) {
            switch (item.type) {
                case 1:
                case 2:
                    preAds.push(item);
                    break;
                case 3:
                    pauseAds.push(item);
                    break;
                case 4:
                    cornerAds.push(item);
                    break;
                case 5:
                    bannerAds.push(item);
                    break;
                default:
                    preAds.push(item);
                    break;
            }
        }

        return {
            1: preAds,
            3: pauseAds,
            4: cornerAds,
            5: bannerAds,
        };
    }

    getFlag(arr, type) {
        const obj = {};

        for (let i = 0, len = arr.length; i < len; i++) {
            const item = arr[i];

            if (type === item.type) {
                const start = item.eventlog.start || [];
                const middle = item.eventlog.middle || [];
                const end = item.eventlog.end || [];
                const tempArr = start.concat(middle, end);

                for (let j = 0, tLen = tempArr.length; j < tLen; j++) {
                    obj[tempArr[j]] = false;
                }
            }
        }

        return obj;
    }

    // type : 1-广告和片头，2-暂停广告，3-角标, index : 各类型广告索引, time : 2\3类型广告不传
    send(type, index, time) {
        let curLog = [];
        let curFlag = {};

        switch (type) {
            case 1:
                curLog = this.getCurrentLog(index, time);
                curFlag = this.preFlag;
                break;
            case 3:
                curLog = this.pauseAds[index].eventlog.start || []; //   暂停、角标广告只有start
                curFlag = this.pauseFlag;
                break;
            case 4:
                curLog = this.cornerAds[index].eventlog.start || [];
                curFlag = this.cornerFlag;
                break;
            case 5:
                curLog = this.bannerAds[index].eventlog.start || [];
                curFlag = this.bannerFlag;
                break;
            default:
                break;
        }

        if (curLog.length === 0) return;

        for (const tmpLog of curLog) {
            if (!curFlag[tmpLog]) {
                curFlag[tmpLog] = true; // 对已发曝光监测做标记，避免重发
                this.postLog(tmpLog);
            }
        }

        for (const log in curFlag) {
            if (log !== curLog[0]) {
                if (!curFlag[log]) {
                    // 对之前漏发的曝光监测补发并做标记，避免遗漏
                    curFlag[log] = true;
                    this.postLog(log);
                }
            } else {
                break;
            }
        }
    }

    getCurrentLog(index, time) {
        const diffTime = Math.ceil(time); // console.log('diffTime:'+diffTime);
        const current = this.preAds[index];
        const currentDuration = Math.ceil(current.duration); // console.log('currentDuration:'+currentDuration);
        let cLog = [];

        switch (diffTime) {
            case 1:
                cLog = current.eventlog.start || [];
                break;
            case Math.ceil(currentDuration / 2):
                cLog = current.eventlog.middle || [];
                break;
            case currentDuration:
                cLog = current.eventlog.end || [];
                break;
        }

        return cLog;
    }

    // 参数参见send接口说明
    sendClick(type, index) {
        let curLog = [];

        switch (type) {
            case 1:
                curLog = this.preAds[index].eventlog.clickTrack;
                break;
            case 3:
                curLog = this.pauseAds[index].eventlog.clickTrack || [];
                break;
            case 4:
                curLog = this.cornerAds[index].eventlog.clickTrack;
                break;
            case 5:
                curLog = this.bannerAds[index].eventlog.clickTrack;
                break;
            default:
                break;
        }

        for (const tmpLog of curLog) {
            this.postLog(tmpLog);
        }
    }

    postLog(url) {
        const img = new Image();

        img.src = url;
    }
}

export default Adcount;
